export const appTopUps = {
  name: '充值 |||| 充值紀錄',
  fields: {
    id: '交易編號',
    user: '用戶',
    userId: '用戶 ID',
    userName: '姓名',
    userEmail: '電郵',
    amount: '金額',
    paymentMethod: '付款方式',
    status: '狀態',
    timestamp: '日期',
    referenceType: '參考類型',
    referenceId: '參考編號',
    adminNotes: '管理備註',
    actions: '操作',
  },
  statuses: {
    pending: '處理中',
    completed: '已完成',
    failed: '失敗',
    cancelled: '已取消',
    refunded: '已退款',
  },
  filters: {
    search: '搜尋（電郵／電話／姓名）',
    status: '狀態',
    statusAll: '全部',
    fromDate: '由',
    toDate: '至',
    today: '今天',
    thisWeek: '本週',
    thisMonth: '本月',
  },
  summary: {
    today: '今天',
    thisWeek: '本週',
    thisMonth: '本月',
    pendingFailed: '處理中 / 失敗',
    transactions: '筆交易',
    refundedToday: '今天退款',
    errorTitle: '無法載入充值統計',
    retry: '重試',
  },
  actions: {
    refund: '退款',
    refresh: '重新整理',
    export: '匯出',
    exportSuccess: '已下載匯出檔案',
    exportFailed: '匯出失敗',
  },
  show: {
    title: '充值詳情',
    sectionTopUpInfo: '充值資訊',
    sectionUser: '用戶',
    sectionPaymentDetails: '付款詳情',
    sectionRefund: '退款',
    refundHint: '透過 BBMSL 將金額全數退回用戶原付款方式，並從用戶錢包中扣除相應金額。',
  },
  refund: {
    title: '退回充值',
    topUpAmount: '充值金額',
    currentBalance: '現時錢包餘額',
    projectedBalance: '退款後預計錢包餘額',
    spentWarningTitle: '用戶已使用部份此次充值',
    spentWarningBody: '錢包餘額將變為負數。用戶需要再次充值才能開始下次充電。確定要繼續處理退款？',
    gatewayNote: 'BBMSL 將會被呼叫，將全數金額退回用戶的原付款方式。',
    reason: '退款原因（必填）',
    cancel: '取消',
    confirm: '確認退款',
    confirmNegative: '仍要退款',
    success: '退款已成功處理',
    failed: '退款失敗',
    balanceUnknownTitle: '無法取得現時錢包餘額',
    balanceUnknownBody: '無法計算退款後的預計錢包餘額。請關閉此對話框後重試，或先檢查 API 錯誤再繼續。',
  },
};
